import register from 'preact-custom-element';
import BeforeAfterSlider from './BeforeAfterSlider';

register(BeforeAfterSlider, 'before-after-slider');
